var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWisdomAiButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3155_1101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.626,
    cy: 42,
    rx: 28.626,
    ry: 30,
    fill: "#726FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0349 31.5051C33.0349 31.5051 33.5275 30 35.1011 30C36.1142 30 36.573 30.0954 37.2381 31.5051C37.697 32.4777 45.3183 48.9509 45.3183 48.9509C45.3183 48.9509 45.7494 49.705 46.1805 49.705C46.6116 49.705 46.7902 49.4896 46.8087 48.8986C46.8271 48.3076 46.781 37.8888 46.781 37.8888C46.781 37.8888 46.667 35.7281 48.9827 35.7096C51.0828 35.6911 51.0304 37.7903 51.0304 37.7903V48.954C51.0304 48.954 50.9226 54.0203 46.3991 53.9064C42.8425 53.8172 41.3367 49.7081 41.3367 49.7081L35.3166 36.4083C35.2058 36.1621 34.8517 36.1713 34.7562 36.4237L31.9633 43.6784C31.9633 43.6784 34.4945 42.7088 35.8956 42.8166C37.2966 42.9243 37.6415 43.7646 37.7801 44.4325C37.9587 45.2943 37.6723 46.7656 36.1635 47.018C34.0141 47.375 31.6368 46.9564 28.0833 52.509C26.6021 54.8237 25.1118 53.7525 25.1118 53.7525C25.1118 53.7525 23.5167 53.0077 24.8346 50.5699L33.0379 31.5082L33.0349 31.5051ZM48.9026 30C47.7294 30 46.7779 30.9511 46.7779 32.1238C46.7779 33.2965 47.7294 34.2476 48.9026 34.2476C50.0758 34.2476 51.0273 33.2965 51.0273 32.1238C51.0273 30.9511 50.0758 30 48.9026 30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3155_1101",
    x: 0,
    y: 0,
    width: 77.252,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3155_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3155_1101",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWisdomAiButton);
export default __webpack_public_path__ + "static/media/wisdom-ai-button.297fd9ab237144e76795f50313d8db8b.svg";
export { ForwardRef as ReactComponent };